import { ADMIN_URLS } from "../../apiConfig.js";
import { ROLE_ERRORS } from "../../../common/constants/adminModule/roleConstants.js";
import { PERMISSION_ERRORS } from "../../../common/constants/adminModule/permissionConstants.js";
import apiClient from "../../apiInstance";

export const getUserRoles = async () => {
    try {
        const response = await apiClient.get(ADMIN_URLS.FETCH_ROLES);
        return response.data;
    } catch (error) {
        console.error(ROLE_ERRORS.FETCH_ROLES_ERROR, error);
        throw error;
    }
};

export const getMenuList = async () => {
    try {
        const response = await apiClient.get(ADMIN_URLS.FETCH_MENUS);
        return response.data;
    } catch (error) {
        console.error(PERMISSION_ERRORS.FETCH_MENUS_ERROR, error);
        throw error;
    }
};

export const getRolePermissions = async (roleId) => {
    try {
        const response = await apiClient.get(`${ADMIN_URLS.FETCH_ENABLED_MENUS}${roleId}`);
        return response.data;
    } catch (error) {
        console.error(PERMISSION_ERRORS.FETCH_MENUS_ERROR, error);
        throw error;
    }
};

export const updateRolePermissions = async (roleId, { toAddAccess, toRemoveAccess }) => {
    const response = await apiClient.post(`${ADMIN_URLS.UPDATE_MENU_PERMISSIONS}`, {
        roleId,
        toAddAccess,
        toRemoveAccess
    });
    return response.data;
};